export const NOTIFICATION_CENTER_ORIGIN = "notification-center";
export const DASHBOARD_ORIGIN = "dashboard";

export type TimelineOrigin =
	| typeof NOTIFICATION_CENTER_ORIGIN
	| typeof DASHBOARD_ORIGIN;
